module.exports = __webpack_public_path__ + "img/19_Lower-rectrum.64a781ae.png";